<div class="h-5/6">
  <app-attendee-header></app-attendee-header>
  <main class="h-full flex flex-col items-center justify-center">
    <h1 class="vtmn-title-4 mb-4">
      {{ 'checkout.failure.title' | translate }}
    </h1>
    <p class="mb-4">{{ 'checkout.failure.description' | translate }}</p>
    <a
      app-vtmn-play-button
      [routerLink]="'/attendee.homepage' | localize"
      [size]="vtmnPlayButtonSize.SMALL"
    >
      {{ 'checkout.failure.button' | translate }}
    </a>
  </main>
</div>
